var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context"},[_c('overview',{on:{"changeData":_vm.getMonthData}}),_c('card-grid'),_c('ChartLine',{on:{"random":_vm.random}}),_c('Compare',{on:{"transfer":_vm.getUser}}),_c('Compare1'),_c('Compare2'),_c('CompareMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }